import { atom } from "recoil"
import localStorageEffect from "../libs/localStorageEffect"

export const navMain = atom({
  key: "navMain_state",
  default: true,
  effects_UNSTABLE: [localStorageEffect("navMain_state")],
})
